export default __webpack_public_path__ + "static/32-222ec0dfbfb0ebaf82d82af68850aeed.png";